'use strict';

var jsxRuntime = require('react/jsx-runtime');

const WidePaperPayment = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-wide_paper_payment--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M6 13H50C52.2091 13 54 14.7909 54 17V46C54 48.2091 52.2091 50 50 50H6V13Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M43 8C42.4477 8 42 8.44772 42 9V40.5C42 41.0523 42.4477 41.5 43 41.5H49.5C51.6315 41.5 54 43 54 45V14C54 10.6863 51.3137 8 48 8H43Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M34 21L14 21",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M28 27L14 27",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M21 33L14 33",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M40.5564 24.6214C41.9232 23.2545 44.1393 23.2545 45.5061 24.6214C46.873 25.9882 46.873 28.2043 45.5061 29.5711L33.2565 41.8207L27.1213 43.0061L28.3068 36.8709L40.5564 24.6214Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M28.8892 36.2886L33.8389 41.2383",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M39.4956 25.682L44.4454 30.6318",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M19.9998 38L18.6547 43L17.2998 38",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M19.71 40.1799H20.71",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M14.6001 38L15.9501 43L17.3001 38",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M15 40.1799H14",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-wide_paper_payment",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M6 13H50C52.2091 13 54 14.7909 54 17V46C54 48.2091 52.2091 50 50 50H6V13Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M43 8C42.4477 8 42 8.44772 42 9V40.5C42 41.0523 42.4477 41.5 43 41.5H49.5C51.6315 41.5 54 43 54 45V14C54 10.6863 51.3137 8 48 8H43Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M34 21L14 21",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M28 27L14 27",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M21 33L14 33",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M40.5564 24.6214C41.9232 23.2545 44.1393 23.2545 45.5061 24.6214C46.873 25.9882 46.873 28.2043 45.5061 29.5711L33.2565 41.8207L27.1213 43.0061L28.3068 36.8709L40.5564 24.6214Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M28.8892 36.2886L33.8389 41.2383",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M39.4956 25.682L44.4454 30.6318",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M19.9998 38L18.6547 43L17.2998 38",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M19.71 39.4799H19.01V40.8799H19.71V39.4799ZM20.71 40.8799C21.0966 40.8799 21.41 40.5665 21.41 40.1799C21.41 39.7933 21.0966 39.4799 20.71 39.4799V40.8799ZM19.71 40.8799H20.71V39.4799H19.71V40.8799Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M14.6001 38L15.9501 43L17.3001 38",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M15 40.1799H14",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = WidePaperPayment;
